import React from 'react';
import { type BankDetails } from './types';

interface BankDetailsFormProps {
  bankDetails: BankDetails;
  setBankDetails: (details: BankDetails) => void;
}

const BankDetailsForm: React.FC<BankDetailsFormProps> = ({ bankDetails, setBankDetails }) => {
  const fields: { id: keyof BankDetails; label: string }[] = [
    { id: 'accountName', label: 'Account holder' },
    { id: 'accountNumber', label: 'Account number' },
    { id: 'bankName', label: 'Bank name' },
    { id: 'ifscCode', label: 'IFSC code' },
  ];

  return (
    <div className="rounded-md border border-zinc-200 bg-zinc-50/50 p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-zinc-900">Bank account</h3>
      <p className="mt-0.5 text-xs text-zinc-500">Used when online settlement is enabled.</p>
      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        {fields.map(({ id, label }) => (
          <div key={id}>
            <label className="app-label">{label}</label>
            <input
              type="text"
              value={bankDetails[id]}
              onChange={(e) => setBankDetails({ ...bankDetails, [id]: e.target.value })}
              className="app-field"
              placeholder={label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankDetailsForm;
